import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { SystemIndexSetsTypes } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  pagination: { total: 0 },
  list: [],
  attributes: []
};
export const queryKey = (searchParams, field, streams) => [
  "fieldTypeUsages",
  searchParams,
  field,
  streams
];
export const fetchFieldTypeUsages = async ({ field, streams }, searchParams) => {
  const {
    sort: { attributeId, direction },
    page,
    pageSize
  } = searchParams;
  const body = { field, streams: streams.length ? streams : void 0 };
  return SystemIndexSetsTypes.fieldTypeSummaries(body, attributeId, page, pageSize, direction).then(
    ({ elements, total, attributes }) => ({
      list: elements.map(({ stream_titles, index_set_title, index_set_id, types }) => ({
        streamTitles: stream_titles,
        types,
        id: index_set_id,
        indexSetTitle: index_set_title
      })),
      pagination: { total },
      attributes
    })
  );
};
const useFieldTypeUsages = ({ streams, field }, searchParams, { enabled } = { enabled: true }) => {
  const { data, refetch, isInitialLoading, isLoading } = useQuery({
    queryKey: queryKey(searchParams, field, streams),
    queryFn: () => defaultOnError(
      fetchFieldTypeUsages({ streams, field }, searchParams),
      `Loading ${field} types failed with status`,
      "Could not load field types"
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    refetch,
    isInitialLoading,
    isLoading
  };
};
export default useFieldTypeUsages;
